import { render, staticRenderFns } from "./InputField.vue?vue&type=template&id=580d95f5&scoped=true"
import script from "./InputField.vue?vue&type=script&lang=js"
export * from "./InputField.vue?vue&type=script&lang=js"
import style0 from "./InputField.vue?vue&type=style&index=0&id=580d95f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580d95f5",
  null
  
)

export default component.exports